import {AssetLunarExchangeOptionPostDataTransferObject} from "../../data-transfer-object/asset/AssetLunarExchangeOptionPostDataTransferObject"

/**
 * 루나 교환 옵션 속성 설명
 */
export const AssetLunarExchangeOptionPostDataTransferObjectDescription: Record<keyof AssetLunarExchangeOptionPostDataTransferObject, string> = {
    lunarAmount: '지급 루나',
    solarAmount: '소모 솔라'
}
